import { intersection } from "lodash"

import { iArticleContent, iArticleContentData } from "../../types"

export const getGlobalTranslations = (
  content: iArticleContent[]
): string[] | null => {
  if (!content) return null
  if (content.length === 0) return null

  const getTranslations = (item: iArticleContentData | undefined | null) => {
    if (!item) return []
    if (!item.translations) return []
    const translations = item.translations.filter((item: any) => Boolean(item))
    if (translations.length === 0) return []
    return translations
      .map((item: any) => item.language)
      .filter((item: any) => Boolean(item)) // removing any null language values
  }

  const allTranslationsLists = content
    .map(({ title, heading, paragraph, bullets }) =>
      [
        getTranslations(title),
        getTranslations(heading),
        getTranslations(paragraph),
        // @ts-ignore
        getTranslations(bullets),
      ].filter((item: any) => Boolean(item.length))
    )
    .map((item: any) => item[0])
  return intersection(...allTranslationsLists)
}
